module.exports = __webpack_public_path__ + "img/logo1.590feb56.png";